import {
  action,
  observable,
  makeObservable,
  runInAction,
} from "mobx";
import api from "../../../../api";
import { Modal, message } from "antd";
import CommonStore from "../../common_store";
// import { CheckboxValueType } from "antd/es/checkbox/Group";
import axios from "axios";

class XNumberManageStore {
  //搜索表单字段
  @observable searchForm: powerSearchData = {};
  @observable searchFormModal: powerSearchData = {};
  @observable tableData: any = {};
  //表格加载状态
  @observable tableLoad: boolean = true;
  //分页信息
  @observable pageData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageData.page = page;
        this.pageData.size = size;
        this.pageData = { ...this.pageData };
      });
      this.manageXPoolNumberPage();
    },
  };
  @observable templateModal:boolean = false
  // X池读的权限
  @observable getAllXPoolReadInfo: any = [];
  // X池编辑的权限
  @observable getAllXPoolWriteInfo: any = [];
  //点击编辑框传值
  @observable lookPower: any = {};
  //报备书文件
  @observable formData:any = null
  //是否上传报备书文件
  @observable approval:boolean = false
  //预览的分页信息
  @observable pageDataModal: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageDataModal.page = page;
        this.pageDataModal.size = size;
        this.pageDataModal = { ...this.pageDataModal };
      });
      this.previewPage(this.batchNumber);
    },
  };
  //预览搜索表单字段
  @observable tableDataModal: any = {};
  //新增批次号
  @observable batchNumber: string = "";
  // @observable checkedList: CheckboxValueType[] = [];
  @observable checkedList: string[] = [];
  //预览数据错误类型统计
  @observable previewCountData: any = {};
  //控制预览弹框提交按钮
  @observable allowSubmit: boolean = false;
  //X池号码数据统计
  @observable statisticsData: any = {};
  //错误类型下载
  @observable exportErrorFlag: any = false;
  //控制批量新增弹框
  @observable updateModal: any = false;
  //按钮的loading状态
  @observable buttonLoading: boolean = false;
  //批量新增传的号池id
  @observable xpoolNo: any = '';
  @observable spinning: boolean = false;

  commonStore: CommonStore;
  constructor(baseStore: CommonStore) {
    this.commonStore = baseStore;
    makeObservable(this);
  }

  setSearchForm(obj: powerSearchData) {
    runInAction(() => {
      this.searchForm = obj;
    });
  }

  setSearchModalForm(obj: powerSearchData) {
    runInAction(() => {
      this.searchFormModal = obj;
    });
  }

  //重置分页
  resetPage() {
    runInAction(() => {
      this.pageData.page = 1;
      this.pageDataModal.page = 1;
    });
  }

  setLookPower(obj: any) {
    runInAction(() => {
      this.lookPower = obj;
    });
  }

  //分页查询X池号码
  @action
  manageXPoolNumberPage() {
    runInAction(() => {
      this.tableData = {};
      this.tableLoad = true;
    });
    const data = { ...this.searchForm };
    data.size = this.pageData.size;
    data.page = this.pageData.page;

    api.xNumberManageApi
      .manageXPoolNumberPage(data)
      .then((res: any) => {
        this.getAllXPool(0);
        this.statistics(this.searchForm.middleNumberPoolNo);
        if (res.code == 200) {
          runInAction(() => {
            this.tableData = res.data;
            this.tableData = { ...this.tableData };
            this.tableLoad = false;
          });
          this.commonStore.getPagePermission("xpool_number_management");
        }
      })
      .catch((e: any) => {
        runInAction(() => {
          this.tableLoad = false;
        });
      });
  }

  //批量新增 X池号码预览
  @action
  addPreview(info: any) {
    const formData = new FormData();
    formData.append("file", info.file as any);
    api.xNumberManageApi
      .addPreview(this.xpoolNo, formData )
      .then(async (res: any) => {
        runInAction(() => {
          this.batchNumber = res.data.batchNumber;
          this.exportErrorFlag = res.data.exportErrorFlag;
          this.templateModal = true
          // this.updateModal = false
          // this.buttonLoading = false
          this.spinning = false
        });
        this.previewPage(this.batchNumber);
        this.previewCount();
      })
      .catch((e: any) => {
        runInAction(() => {
          this.spinning = false
        });
      });

  }

  //预览数据分页查询
  @action
  previewPage(batchNumber?: string) {
    runInAction(() => {
      this.tableDataModal = {};
      this.tableLoad = true;
    });
    const data = { ...this.searchFormModal };
    console.log(this.pageDataModal);

    data.size = this.pageDataModal.size;
    data.page = this.pageDataModal.page;
    data.batchNumber = batchNumber ? batchNumber : this.batchNumber;
    api.xNumberManageApi
      .previewPage(data)
      .then((res: any) => {
        if (res.code == 200) {
          runInAction(() => {
            this.tableDataModal = res.data;
            this.tableDataModal = { ...this.tableDataModal };
            this.tableLoad = false;
          });
        }
      })
      .catch((e: any) => {
        runInAction(() => {
          this.tableLoad = false;
        });
      });
  }

  //提交到飞书审核 ， 批量新增X池号码预览
  @action
  addApproval(info: any) {
    runInAction(() => {
      this.tableLoad = true;
      this.buttonLoading = true;
    });
    const formData = new FormData();
    formData.append("file", info.file as any);
    api.xNumberManageApi
      .addApproval(this.batchNumber, formData )
      .then(async (res: any) => {
        runInAction(() => {
          this.templateModal = false
          this.searchFormModal = {};
          this.approval =false
          this.tableLoad = false;
          this.buttonLoading = false;
        });
        this.resetPage();
      })
      .catch((e: any) => {});
  }

  //预览数据错误类型统计
  @action
  previewCount() {
    api.xNumberManageApi
      .previewCount(this.batchNumber)
      .then((res: any) => {
        runInAction(() => {
          this.previewCountData = res.data;
        });
        this.changeCheckList([]);
      })
      .catch((e: any) => {});
  }

  //查询当前账户全部x池
  @action
  getAllXPool(data:number) {
    api.xNumberManageApi
      .getAllXPool(data)
      .then(async (res: any) => {
          if(data === 0){
            runInAction(() => {
              this.getAllXPoolReadInfo = res.data;
            });
          }else{
            runInAction(() => {
              this.getAllXPoolWriteInfo = res.data;
            });
          }
      })
      .catch((e: any) => {});
  }

  @action changeCheckList(list: string[]) {
    console.log('CheckboxValueType',list);

    this.checkedList = [...list];
    let newpreviewCountData = { ...this.previewCountData };
    delete newpreviewCountData.total
    this.checkedList.forEach((item: any) => {
      if (
        item === "poolRepeat" ||
        item === "tableRepeat" ||
        item === "numberNotExist" ||
        item === "otherError"
      ) {
        delete newpreviewCountData[item];
      }
    });
    let sum = 0;
    let arr: any = Object.values(newpreviewCountData);
    for (var i = arr.length - 1; i >= 0; i--) {
      sum += arr[i];
    }
    if(this.previewCountData.total === (this.previewCountData.poolRepeat + this.previewCountData.tableRepeat + this.previewCountData.numberNotExist + this.previewCountData.otherError)){
      runInAction(() => {
        this.allowSubmit = true;
      });
    }else{
      runInAction(() => {
        this.allowSubmit = !Boolean(sum === 0) ;
      });
    }
  }

  //错误数据导出
  @action
  exportError() {
    api.xNumberManageApi
      .exportError({ batchNumber: this.batchNumber })
      .then(async (res: any) => {
        message.success("错误数据导出成功");
      })
      .catch((err: any) => {
        const blob = new Blob([err], {
          type: 'application/vnd.ms-excel'
        })
        if ('download' in document.createElement('a')) {
          // 生成<a></a >DOM元素
          const link = document.createElement('a')
          link.download = '错误数据导出.xlsx'
          link.style.display = 'none'
          // a标签的href属性指定下载链接
          link.href = URL.createObjectURL(blob)
          document.body.appendChild(link)
          // 必须点击否则不会下载
          link.click()
          URL.revokeObjectURL(link.href)// 释放URL 对象
          document.body.removeChild(link)
        }
      });
  }

  //X池号码数据统计
  @action
  statistics(data:any) {
    api.xNumberManageApi
      .statistics({middleNumberPoolNo:data})
      .then(async (res: any) => {
        runInAction(() => {
          this.statisticsData = res.data;
        });
      })
      .catch((e: any) => {});
  }

  //取消新增预览弹框
  @action cancelPreview = (data?: any) => {
    runInAction(() => {
      this.templateModal = false
      this.searchFormModal = {}
      this.approval =false
    });
    this.resetPage();
  };

  //批量新增弹框上传号码文件
  @action controlAdd = (data?: any) => {
    this.getAllXPool(1);
    runInAction(() => {
      this.updateModal = !this.updateModal
      this.formData = null
      this.xpoolNo = ''
    });
  };

}

export default XNumberManageStore;
